import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpandAll = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m24 43.775-11.85-11.85 2.125-2.1L24 39.55l9.75-9.725 2.1 2.1zm-9.75-25.6-2.1-2.1L24 4.225l11.85 11.85-2.1 2.1L24 8.45z" })
});
export default SvgExpandAll;
